import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "defaultValue", "displayFormat", "disabled", "label", "hintMessage", "icon", "rightTextLink", "bgColor", "alwaysShowAsHint", "onChange"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/InputText/InputText.js";
import React, { useRef } from 'react';
import MaskedInput from './MaskedInput';
import styled, { css } from 'styled-components';
import { noop, testIdProps } from '../../helpers';
import FormField from '../../core/components/Forms/FormField';
import FormInput from '../../core/components/Forms/FormInput';
import LabelText from '../../core/components/Forms/LabelText';
import HintText from '../../core/components/Forms/HintText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import { withTheme } from '../../core/ThemeProvider';
/* eslint-disable-next-line react/display-name */

var InputText = /*#__PURE__*/React.forwardRef(function InputText(props, ref) {
  /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
  var error = props.error,
    defaultValue = props.defaultValue,
    displayFormat = props.displayFormat,
    disabled = props.disabled,
    label = props.label,
    hintMessage = props.hintMessage,
    icon = props.icon,
    rightTextLink = props.rightTextLink,
    bgColor = props.bgColor,
    alwaysShowAsHint = props.alwaysShowAsHint,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var value = useRef(defaultValue);
  var handleRightTextLinkClick = function handleRightTextLinkClick(e) {
    blockFieldInteraction(e);
    rightTextLink.onClick && rightTextLink.onClick(e, value.current);
  };
  var _onChange = function _onChange(e, rawValue) {
    value.current = e.target.value;
    if (typeof onChange === 'function') {
      onChange(e, rawValue);
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, testIdProps(props), {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(FormField, {
    disabled: disabled,
    defaultValue: defaultValue,
    error: error,
    bgColor: bgColor,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InputContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  }, displayFormat ? /*#__PURE__*/React.createElement(MaskedInput, _extends({}, rest, testIdProps({}, 'inputField'), {
    onChange: _onChange,
    ref: ref,
    disabled: disabled,
    displayFormat: displayFormat,
    defaultValue: defaultValue,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(FormInput, _extends({}, rest, testIdProps({}, 'inputField'), {
    onChange: _onChange,
    disabled: disabled,
    defaultValue: defaultValue,
    ref: ref,
    alwaysShowAsHint: alwaysShowAsHint,
    as: "input",
    error: props.error,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 13
    }
  })), (icon || rightTextLink) && /*#__PURE__*/React.createElement(InputAdornment, {
    onClick: blockFieldInteraction,
    onMouseDown: blockFieldInteraction,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 13
    }
  }, icon && /*#__PURE__*/React.createElement(AdornmentImage, {
    src: icon.src,
    alt: icon.alt,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 24
    }
  }), rightTextLink && /*#__PURE__*/React.createElement(AdornmentText, {
    onClick: handleRightTextLinkClick,
    "data-testid": "textLinkId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 17
    }
  }, rightTextLink.text))), /*#__PURE__*/React.createElement(LabelText, {
    "data-testid": "input-label",
    alwaysShowAsHint: alwaysShowAsHint,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 9
    }
  }, label)), hintMessage && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: error,
    "data-testid": "hintId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 11
    }
  }, hintMessage)));
});
InputText.defaultProps = {
  disabled: false,
  error: false,
  onChange: noop,
  type: 'text',
  bgColor: 'white'
};
// Prevent click and mouse events to propagate down to the input field.

var blockFieldInteraction = function blockFieldInteraction(e) {
  e.preventDefault();
  e.stopPropagation();
};
/**
 * Container for placing UI on the left or the right side of the input field.
 * @param {'end'|'begin'} position Where to place the UI.
 */

var InputAdornment = styled.div.withConfig({
  displayName: "InputText__InputAdornment",
  componentId: "sc-1wwpxbl-0"
})(function (p) {
  return css(["position:relative;bottom:10px;display:flex;padding:0 0 0 8px;flex-direction:column;justify-content:center;align-items:center;", ""], p.position === 'end' ? {
    left: 0
  } : {
    right: 0
  });
});
var AdornmentImage = styled.img.withConfig({
  displayName: "InputText__AdornmentImage",
  componentId: "sc-1wwpxbl-1"
})(["width:40px;"]);
var AdornmentText = withTheme(styled.span.withConfig({
  displayName: "InputText__AdornmentText",
  componentId: "sc-1wwpxbl-2"
})(["padding:4px 0;font-family:", ";color:", ";direction:rtl;", ""], function (p) {
  return p.coreTheme.ff_sec_bold;
}, function (p) {
  return p.coreTheme.cl_sec_d1;
}, function (p) {
  return p.onClick && {
    cursor: 'pointer'
  };
}));
var InputContainer = styled.div.withConfig({
  displayName: "InputText__InputContainer",
  componentId: "sc-1wwpxbl-3"
})(["display:flex;height:30px;"]);
export default InputText;